import swal from 'sweetalert';
import axios from 'axios'
import router from "../router";
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
axios.interceptors.request.use(config => {
  let urlAllow = [
    "https://etaxgateway.one.th/authenportal/login/v2", 
    "https://service-etax.one.th/etaxdatetime/init",
    "https://etax.one.th/proxy_regetaxsp/api/getaccusr_getbusiness",
    "https://etax.one.th/proxy_regetaxsp/api/usr_getbusiness",
    "https://service-etax.one.th/option-abb/api/v1/regis_etax_r1",
    "https://service-etax.one.th/etaxstatistics/maintenance",
    "https://etaxgateway.one.th/portalreport_processlog/SendEbxml-Submit/Preview",
    "https://etaxgateway.one.th/portalreport_processlog/SendEbxml-Submit/Send",
    "https://etaxgateway.one.th/portalreport_processlog/CheckToken",
    "https://etaxgateway.one.th/authenportal/verify_otp",
    "https://etaxgateway.one.th/authenportal/verify_otp_option",
    "https://etaxgateway.one.th/authenportal/loginSSO",
    "https://etaxgateway.one.th/serviceconfig_template/web_activity_log",
    "https://service-etax.one.th/option-service/get_user_type",
    "https://service-etax.one.th/option-service/login/r2",
    "https://one.th/api/v2/service/shared-token",
    "https://service-etax.one.th/admin-api/customer_satisfaction/users/form",
    "https://service-etax.one.th/admin-api/customer_satisfaction/users/answer",
  ]
  // เพิ่ม header Permission
  config.headers = config.headers || {}
  config.headers.Permission = process.env.VUE_APP_PERMISSION_PASS_TOKEN

  let urlSub = config.url.lastIndexOf("/");
  let resultUrl = config.url.substring(0, urlSub);
  if(resultUrl == "https://one.th/api/service/business/account") {
    return config;
  }else if (!urlAllow.includes(config.url)) {
    if (localStorage.getItem('STID') === null ||
      localStorage.getItem('Username') === null ||
      localStorage.getItem('SELLERID') === null ||
      localStorage.getItem('Access') === null ||
      Vue.$cookies.isKey("Access") === false ||
      Vue.$cookies.isKey("STID") === false ||
      Vue.$cookies.isKey("Username") === false
    ) {
      swal({
        title: "Session หมดอายุ",
        text: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "เข้าสู่ระบบ",
            value: "yes"
          }
        }
      }).then(value => {
        switch (value) {
          case "yes":
            router.push("/portal/login")
            break;
        }
      });
    } else {
      return config;
    }
  } else {
    return config;
  }
});
export default axios


// WEBPACK FOOTER //
// ./src/plugins/axios.js